module.exports = __webpack_public_path__ + "img/redBrickBallon.c477d424.png";